<template>
  <div class="specificrb-info part">
    <template v-if="isEdit!==`specific-${type}`">
      <div v-for="item in data[personJournalList]"
           :key="item.id">
        <div class="mar-b-12">
          <span class="ipub-block__span"
                style="width:200px">{{item.name}} {{type === 'rb'? 'Reviewer’s Identity':'Editor’s Identity'}}</span>
          <div class="ipub-block__font"
               style="width:calc(100% - 220px)"> {{type==='rb'?reviewType[item.identityCode]:editorialBoard[item.identityCode]}}
          </div>
        </div>
        <div class="mar-b-12">
          <span class="ipub-block__span"
                style="width:200px">Hierarchy</span>
          <div class="ipub-block__font"
               style="width:calc(100% - 220px)">{{item.sort}}</div>
        </div>
      </div>
      <!-- <div class="mar-b-12"
           v-if="type==='rb'">
        <span class="ipub-block__span"
              style="width:200px">Research Keywords</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 220px)">{{data.keyword?(data.keyword.includes(',')?data.keyword.split(',').join('; ') :data.keyword):'--'}}
        </div>
      </div> -->
    </template>
    <template v-else>
      <ipub-form :ref="`specific-${type}`"
                 :model="form"
                 :rules="rules">
        <ipub-row :gutter="20"
                  v-for="item in form[personJournalList]"
                  :key="item.id">
          <ipub-col :span="6">
            <ipub-form-item prop='reviewerJournalList'>
              <div class="ipub-p2 fw-bd mar-b-10 relative">
                {{item.name}} {{type === 'rb'? 'Reviewer’s Hierarchy':'Editor’s Hierarchy'}}
                <div class="right-option ipub-p4 link-color">
                </div>
              </div>
              <ipub-input number
                          v-model="item.sort" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop='reviewerJournalList'>
              <div class="ipub-p2 fw-bd mar-b-10 relative">
                {{item.name}} {{type === 'rb'? 'Reviewer’s Identity':'Editor’s Identity'}}
                <div class="right-option ipub-p4 link-color">
                </div>
              </div>
              <!-- {{typeList}}{{editorialBoard}} -->
              <ipub-select v-model="item.identityCode"
                           placeholder="Title">
                <ipub-select-option v-for="(value) in reviewTypeList"
                                    v-show="type==='rb' && value.enabled"
                                    :key="value.id"
                                    :value="value.code">
                  {{value.name}}
                </ipub-select-option>
                <ipub-select-option v-for="(value) in editorialBoardList"
                                    v-show="type==='eb' && value.enabled"
                                    :key="value.id"
                                    :value="value.code">
                  {{value.name}}
                </ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col>

        </ipub-row>
      </ipub-form>
      <div class="btns">
        <ipub-button plain
                     style="width:180px"
                     type="primary"
                     @click="back">Cancel</ipub-button>
        <ipub-button style="width:180px;margin-left:20px"
                     type="primary"
                     @click="save">Save</ipub-button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import person from '@/api/person'
import { settingOption } from '@/api/setting'

export default {
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    type: {
      type: String,
      default: ''
    },
    isEdit: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      // isEdit: false,
      form: {
        hindexed: false,
        affiliations: [''],
        reviewJournals: [''],
        reviewerIdentity: '',
      },
      rules: {},
      personJournalList: [],
      editorialBoardList: [],
      reviewTypeList: []
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain',
      language: 'getLanguage',
      title: 'getTitle',
      reviewType: 'getReviewType',
      degree: 'getDegree',
      role: 'getUser',
      editorialBoard: 'getEditorialBoard',
    })
  },
  watch: {
    isEdit (val) {
      if (val === ('specific-' + this.type)) {
        const data = JSON.parse(JSON.stringify(this.data))
        // data.keywords = data.keyword ? data.keyword.split(',') : []
        this.form = data
        this.getData()
      }
    },
    type: {
      handler (newV) {
        if (newV) {
          if (newV === 'rb') {
            this.personJournalList = 'rboardJournalList'
          } else {
            this.personJournalList = 'eboardJournalList'
          }
        }
      },
      immediate: true
    }
  },
  //
  mounted () {
  },
  methods: {
    editInfo () {
      this.isEdit = true
    },
    async getData () {
      const editorialBoardList = await settingOption.get({ type: 'EDITORIAL_BOARD_IDENTITY' })
      const reviewTypeList = await settingOption.get({ type: 'REVIEWER_BOARD_IDENTITY' })
      // console.log(data3, 'data3')
      this.editorialBoardList = editorialBoardList
      this.reviewTypeList = reviewTypeList
    },

    async save () {
      const flag = this.$refs[`specific-${this.type}`].validate()
      if (this.type === 'rb') {
        this.form.type = 1
      } else {
        this.form.type = 2
      }
      if (flag) {
        // this.form.keyword = this.form.keywords
        //   ? this.form.keywords.join(',')
        //   : ''
        await person.editJournal(this.form.id, this.form)
        this.$message.success({
          title: 'Success',
          content: 'This User has been saved!'
        })
        this.$emit('confirm')
      }
    },

    back () {
      this.$emit('cancel')
    },
  }
}
</script>
<style lang="scss" scoped>
.part {
  padding: 4px 16px;
}
</style>
